export default {
  ruminant: {
    name: '16% Dairy Nut Low carbon',
    diet: [
      {
        title: 'Barley (Treated)',
        percentage: 30,
        efValue: 0.31,
      },
      {
        title: 'Beans (Dried)',
        percentage: 10,
        efValue: 0.28,
      },
      {
        title: 'Wheat (Treated)',
        percentage: 10,
        efValue: 0.37,
      },
      {
        title: 'Rapeseed Extraction',
        percentage: 11,
        efValue: 0.4,
      },
      {
        title: 'Distillers',
        percentage: 10,
        efValue: 0.36,
      },
      {
        title: 'Pollard',
        percentage: 9.5,
        efValue: 0.64,
      },
      {
        title: 'Beet Pulp',
        percentage: 10,
        efValue: 0.06,
      },
      {
        title: 'Molasses Blend',
        percentage: 5,
        efValue: 0.15,
      },
      {
        title: 'Special mineral',
        percentage: 2,
        efValue: 0.0,
      },
      {
        title: 'Magnesium Oxide CalMag',
        percentage: 2,
        efValue: 0.0,
      },
    ],
  },
  monogastric: {
    name: 'Low Carbon Pig Fattener Diet',
    diet: [
      {
        title: 'Barley (Treated)',
        percentage: 17,
        efValue: 0.31,
      },
      {
        title: 'Wheat (Treated)',
        percentage: 34,
        efValue: 0.37,
      },
      {
        title: 'Maize',
        percentage: 11.8,
        efValue: 0.45,
      },
      {
        title: 'Beans (Treated)',
        // title: 'Treated Beans',
        percentage: 25,
        efValue: 0.23,
      },
      {
        title: 'Rapeseed Extraction',
        percentage: 8,
        efValue: 0.4,
      },
      {
        title: 'Fat',
        percentage: 1.1,
        efValue: 0,
      },
      {
        title: 'Limestone',
        percentage: 1.1,
        efValue: 0.15,
      },
      {
        title: 'Molasses Blend',
        percentage: 0.6,
        efValue: 0.15,
      },
      {
        title: 'Salt',
        percentage: 0.4,
        efValue: 0.09,
      },
      {
        title: 'Lysine',
        percentage: 0.4,
        efValue: 8.25,
      },
      {
        title: 'Special mineral',
        percentage: 0.3,
        efValue: 0.0,
      },
      {
        title: 'MCP',
        percentage: 0.2,
        efValue: 0.0,
      },
      {
        title: 'Methionine',
        percentage: 0.1,
        efValue: 2.52,
      },
      {
        title: 'Threonine',
        percentage: 0.1,
        efValue: 3.77,
      },
    ],
  },
};
